import moment from 'moment';

export function isWeekend(date) {
  const day = date.day(); // 0 = Sunday, 6 = Saturday
  return day === 0 || day === 6;
}
